import * as React from "react"
import { Attachment } from "../../../types/types";

type Props = {
  image: Attachment
}

export default (props: Props): JSX.Element => (
  <div className='hero__visual' style={{ backgroundImage: `url(${props.image.url})` }}>
    <img className="hero__image" src={props.image.url} />
  </div>
)
